import { Button } from 'antd';
import styled from 'styled-components';

export const StyledTutorialIcon = styled(Button)`
    position: absolute;
    top: 5px;
    right: 34px;
    z-index: 2;
`;

export const StyledPopoverContainer = styled.div`
    display: flex;
    flex-direction: column;
    max-width: 500px;
    gap: 8px;
    width: 85vw;
`;

export const StyledTabContainer = styled.div`
    display: flex;
    flex-direction: column;
    padding: 0 8px;
    max-height: 350px;
    overflow: auto;
`;

export const StyledCodeExample = styled.div`
    border-radius: 6px;
    padding: 12px;
    background-color: #131313;
    color: #FBFBFB;
    text-align: left;
`;

export const StyledHighlightCode = styled.span`
    color: #2e95d3
`;

export const StyledTitle = styled.h4`
    font-size: 16px;
    font-weight: 700;
`;